import { render } from "./ModalDialog.vue?vue&type=template&id=77f99f60&scoped=true"
import script from "./ModalDialog.vue?vue&type=script&lang=js"
export * from "./ModalDialog.vue?vue&type=script&lang=js"

import "./ModalDialog.vue?vue&type=style&index=0&id=77f99f60&scoped=true&lang=css"

import exportComponent from "/srv/m1port/dev/client/patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f99f60"]])

export default __exports__